import React from 'react';

interface SpinnerProps {
    size: number;
    color?: string;
    /** `tail`: arc with fading tail (default), `oval`: arc on a faint full ring */
    variant?: 'tail' | 'oval';
}

const rotate = (duration: string) => (
    <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur={duration} repeatCount="indefinite" />
);

/** Loading spinner (same shapes as the former react-loader-spinner "TailSpin" and "Oval"). */
const Spinner = ({ size, color = 'currentColor', variant = 'tail' }: SpinnerProps) => {
    if (variant === 'oval') {
        return (
            <div aria-busy="true">
                <svg width={size} height={size} viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke={color}>
                    <g fill="none" fillRule="evenodd">
                        <g transform="translate(1 1)" strokeWidth="2">
                            <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
                            <path d="M36 18c0-9.94-8.06-18-18-18">{rotate('1s')}</path>
                        </g>
                    </g>
                </svg>
            </div>
        );
    }

    return (
        <div aria-busy="true">
            <svg width={size} height={size} viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd">
                    <g transform="translate(1 1)">
                        <path d="M36 18c0-9.94-8.06-18-18-18" stroke={color} strokeWidth="2">
                            {rotate('0.9s')}
                        </path>
                        <circle fill="#fff" cx="36" cy="18" r="1">
                            {rotate('0.9s')}
                        </circle>
                    </g>
                </g>
            </svg>
        </div>
    );
};

export default Spinner;
